var _rect, _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentorshipService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64px",
    height: "64px",
    style: {},
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Feedback Audients") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feedback_Audients",
    className: "",
    fillOpacity: 1,
    fill: "#3d43ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.77,57.58a11,11,0,0,0-7-7.91c2.51-2,2.24-4.5,2.24-6.67a6,6,0,0,0-12,0c0,2.24-.27,4.64,2.23,6.66a10.93,10.93,0,0,0-5.4,4.22A12,12,0,0,0,36,47.71c3.21-2.28,3-5.34,3-7.71a7,7,0,0,0-14,0c0,2.22-.34,5.36,3,7.71a12,12,0,0,0-6.8,6.19,10.85,10.85,0,0,0-5.4-4.23c2.51-2,2.24-4.5,2.24-6.67A6,6,0,0,0,6,43c0,2.28-.26,4.64,2.22,6.66a11,11,0,0,0-7,7.92L0,62.78A1,1,0,0,0,2,63.22L3.17,58A9.06,9.06,0,0,1,20.3,56.46c-.07.31.21-1.11-1.28,6.34a1,1,0,0,0,2,.4L22.22,57a10,10,0,0,1,19.56,0L43,63.2a1,1,0,0,0,2-.4c-1.52-7.59-1.22-6.07-1.27-6.33,3.48-8.1,15.2-6.86,17.12,1.55l1.2,5.2A1,1,0,0,0,64,62.78ZM8,45V43a4,4,0,0,1,8,0v2a4,4,0,0,1-8,0Zm19-3V40a5,5,0,0,1,10,0v2a5,5,0,0,1-10,0Zm21,3V43a4,4,0,0,1,8,0v2a4,4,0,0,1-8,0Z",
    id: "svg_1",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,0H4A4,4,0,0,0,0,4V18a4,4,0,0,0,4,4H27.42l3.71,6.5a1,1,0,0,0,1.74,0L36.58,22H60a4,4,0,0,0,4-4V4A4,4,0,0,0,60,0Zm2,18a2,2,0,0,1-2,2H36c-.78,0-.63.09-4,6-3.37-5.89-3.22-6-4-6H4a2,2,0,0,1-2-2V4A2,2,0,0,1,4,2H60a2,2,0,0,1,2,2Z",
    id: "svg_2",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,5.76c-5.05-3.4-12.56,5.07-.45,11.13a1,1,0,0,0,.9,0C44.48,10.87,37.12,2.31,32,5.76Zm0,9.11c-9.25-5.13-3.24-9.7-.71-7.12a1,1,0,0,0,1.42,0C35.25,5.17,41.26,9.73,32,14.87Z",
    id: "svg_3",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.21,8.83,14.09,8.4,12.71,5.56a1,1,0,0,0-1.8,0L9.53,8.4c-2.84.39-3.65.27-3.93,1.11s.23,1,2.53,3.21c-.52,2.91-.85,3.58-.16,4.09s1,.09,3.84-1.41C14.73,17,14.7,17,15.06,17a1,1,0,0,0,1-1.17l-.55-3.11,2.27-2.18A1,1,0,0,0,17.21,8.83Zm-3.5,5.32c-2.2-1.18-1.59-1.18-3.8,0,.43-2.46.61-1.9-1.18-3.62,2.48-.35,2,0,3.08-2.24,1.09,2.24.61,1.89,3.08,2.24C13.08,12.27,13.28,11.7,13.71,14.15Z",
    id: "svg_4",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,9h-.72l.21-.82A2.57,2.57,0,0,0,52,5c-.81,0-.82.4-2.58,3.92A4.11,4.11,0,0,0,49.08,10H46a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h7.72a3,3,0,0,0,2.84-2A10.52,10.52,0,0,0,57,11,2,2,0,0,0,55,9Zm-8,3h2v3H47Zm6.72,3H51c0-5.72-.35-4.07,1.48-7.73.38.63-.94,2.49-.27,3.35.39.49.74.38,2.79.38C55,12.43,55.16,15,53.72,15Z",
    id: "svg_5",
    fill: "#3d43ac"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorshipService);
export default __webpack_public_path__ + "static/media/mentorship-service.1f6939f889ee7afef3b342345e932cbe.svg";
export { ForwardRef as ReactComponent };